export const Application = {
    SCALIBUR: "SCALIBUR",
    PHOENIX: "PHOENIX",
    MARKETPLACE: "MARKETPLACE",
    ASSORTMENT: "ASSORTMENT",
    MANAGEMENT_SUMMARY: "MANAGEMENT_SUMMARY",
    RANKING: "RANKING",
    VALIDATION: "VALIDATION",
    PRODUCTOS: "PRODUCTOS",
};

export const MULTI_PRODUCTS_APPS = [
    Application.PHOENIX,
    Application.MARKETPLACE,
    Application.ASSORTMENT,
    Application.PRODUCTOS,
    Application.MANAGEMENT_SUMMARY,
    Application.RANKING,
];
